<div class="cs-d-flex w-100 h-100 cs-panel-background" *ngIf="!isLoading; else: loader">
    <div class="left-container cs-flex-1 h-100 w-100 pos-rlt" *ngIf="!noData">
        <div class="pos-abt pos-abt-full">
            <div class="cs-d-flex flex-column dag-audit-container h-100 w-100">
                <div class="dag-audit-container--header filter-section filter-comp-container filter-comp-container-automation">
<!--                    fitler-->
                    <app-filter *ngIf="filterOptions.length > 0" id="workflow-filter-margin" class="workflow-filter-margin"
                        screenType="custom_automation"
                        (applyFilter)="applyFilters($event)"
                        (deleteFilter)="removeFilter($event)"
                        parentClassName="filter-comp-container-automation"
                        [widthChangeEvent]="widthChangeEventSubject.asObservable()"
                        [appliedFilters]="appliedViewsFilter"
                        [dynamicPositionId]="'#workflow-filter-margin'"
                        [availableFields]="filterOptions">
                    </app-filter>

                </div>
                <div class="dag-audit-container--content cs-flex-1 pos-rlt" [appCsScrollbar] (psYReachEnd)="onScrollEnd($event)">
                    <ng-container>
                        <div class="cs-d-flex flex-column">
                            <div *ngFor="let item of auditItems; let ind = index"
                                 [ngClass]="{'active': item.id===selectedItem?.id}"
                                 class="cs-d-flex cs-border cs-border--bottom row-item cursor-pointer" (click)="showDiagramPreview(item)">
                                <div class="cs-d-flex flex-column dr-list-item">
                                    <div class="font-bold row-item-title m-b--5">{{ item.title }}</div>
                                    <div class="row-item-desc"> {{ item.description }}</div>
                                    <ng-container [ngSwitch]="item.taskId">
                                       <!-- <ng-container *ngSwitchCase="'cs_initializer'">
                                            <ng-container *ngTemplateOutlet="csInitializer; context: {data: item, fields: fields}"></ng-container>
                                        </ng-container>-->

                                        <ng-container *ngSwitchDefault>
                                            <div *ngIf="item.listItems.length">
                                                <ul style="margin-bottom: 0">
                                                    <li *ngFor="let list of item.listItems">
                                                        <span *ngFor="let text of list">
                                                            <strong *ngIf="text.indexOf('###') == 0">{{ text.replace('###', '') }}</strong>
                                                            <span *ngIf="text.indexOf('###') == -1">{{text}}</span>
                                                        </span>
                                                    </li>
                                                </ul>
                                            </div>
                                        </ng-container>
                                    </ng-container>

                                    <div class="row-item-bottom-title m-t--10">
                                        <div class="m-b--5">{{ item.bottomTitle }}:</div>
                                        <div class="cs-d-flex">
                                            <div class="profile-pic m-r--5">
                                                <img class="w-100" [src]="item.profile" tooltip="{{item.createdBy}}" placement="bottom" container="body" alt="..." />
                                            </div>
                                            <div>{{ item.dateToDisplay }}</div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div  class="cs-d-flex cs-border cs-border--bottom row-item" *ngIf="infiniteScrollOn">
                                <div class="cs-d-flex flex-column dr-list-item w-100">
                                    <div class="ph-item height-100" [style.padding-left]="0" [style.padding-right]="0">
                                        <div class="ph-col-12 height-100" [style.padding-left]="0" [style.padding-right]="0">
                                            <div class="ph-row" [style.align-items]="'center'">
                                                <div class="ph-col-10 m-b--8"></div>
                                                <div class="ph-col-2 empty m-b--8"></div>
                                                <div class="ph-col-8 sm"></div>
                                                <div class="ph-col-4 empty"></div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </ng-container>
                </div>
            </div>
        </div>
    </div>

    <div class="cs-flex-full" *ngIf="!noData; else: noDataTemplate">
        <div class="cs-d-flex flex-column dag-run-container h-100">
            <ng-container *ngIf="isLoadingDiagramView; then loader"></ng-container>
            <div class="dag-run-container--content cs-flex-1" *ngIf="activeDagData && !isLoadingDiagramView; else: noActiveWorkflowTmp;">
                <div class="cs-d-flex cs-d-flex-wrap h-100 w-100" *ngIf="activeDagData['dagSource']; else: noPreviewWorkflowTmp">
                    <app-diagram-view2
                        [nodes]="[]"
                        [nodeOptions]="nodeOptions"
                        [dagSourceData]="activeDagData['dagSource']"
                        direction="vertical">
                    </app-diagram-view2>
                </div>
            </div>
        </div>
    </div>
</div>

<ng-template #loader>
    <div class="cs-d-flex align-items-center justify-center h-100 cs-panel-background">
        <div class="spreadsheet-loading-wrap">
            <span class="loading-spreadsheet">
                <span class="loading-x-axis"></span>
                <span class="loading-y-axis"></span>
                <ng-container *ngFor="let number of [0]">
                    <div class="loading-row row-1"></div>
                    <div class="loading-row row-2"></div>
                    <div class="loading-row row-3"></div>
                    <div class="loading-row row-1"></div>
                    <div class="loading-row row-2"></div>
                </ng-container>
            </span>
        </div>
    </div>
</ng-template>

<ng-template #noDataTemplate>
    <div class="no-results with-large-top-margin" style="margin-top: 0;position: absolute;top: 50%;left: 50%;transform: translate(-50%, -50%);">
        <div class="warning-icon-wrap with-info-icon" style="box-sizing: content-box">
            <span class="ss-info icon fix-left"></span>
        </div>
        <div class="warning-message text-align-center" translate>No data available</div>
    </div>
</ng-template>

<ng-template #noPreviewWorkflowTmp>
    <div *ngIf="!isLoadingDiagramView" class="cs-d-flex cs-d-flex-wrap flex-column align-items-center h-100 w-100 justify-center">
        <div>No preview available for this action</div>
    </div>
</ng-template>

<ng-template #noActiveWorkflowTmp>
    <div *ngIf="!isLoadingDiagramView" class="cs-d-flex cs-d-flex-wrap flex-column align-items-center h-100 w-100 justify-center">
        <div>Please select a record from the left to see the complete audit of that workflow</div>
    </div>
</ng-template>
